var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiverHealth = function SvgLiverHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#537A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.84 6.102c3.287-.54 7.897-.207 8.148 1.084.395 2.032-2.413 4.76-4.669 5.67s-3.48.677-3.48.677m0-7.43c-3.13.514-5.477-.598-8.371 1.446-3.47 2.45-2.475 12.506.676 11.991 1.794-.293 1.86-1.934 3.343-3.986 1.1-1.522 3.1-.701 4.353-2.021m0-7.43c3.337-.55 2.72 4.564 0 7.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.03 15.168c.9.643 0 3.022-1.8 1.736M5.886 12.66c-.15-1.2.193-3.665 2.765-3.922"
  }))));
};
export default SvgLiverHealth;